export const reviews = [
  {
    title: 'LOVE, LOVE, LOVE this app!!! ❤️❤️',
    date: 'Sep 19',
    reviewer: 'Ithai',
    color: '#F8F8F8',
    content:
      'If I could give it 10 stars I would. My favorite thing to use it for is, count downs to annoy my friends with. I also love to use it for cards, posters, and SO much more! And they have so many cute backgrounds and stickers! So I completely suggest you get this app, no matter if you are, like me and aspire to be a graphic designer when your older, or just like to make fun cards.',
  },
  {
    title: 'Love it',
    date: 'Jun 28',
    reviewer: 'Amburleena',
    color: '#F8F8F8',
    content:
      'I do love this app and I use it so much. You can do a lot of different things with it. I even just edited a video for the first time on there.',
  },
  {
    title: 'Easy to use.',
    date: 'Nov 3',
    reviewer: 'Lynnfrombarrie',
    color: '#F8F8F8',
    content: 'Give it a try. Have some fun.',
  },
  {
    title: 'Love It!',
    date: 'Oct 31',
    reviewer: 'LeiaDD13',
    color: '#F8F8F8',
    content: 'I make my kids bday invitation, Diwali greetings, etc here! Works out well!',
  },
  {
    title: 'So easy n fun',
    date: 'Oct 26',
    reviewer: 'FrannaA',
    color: '#F8F8F8',
    content: 'Love how easy it is to put a little image together. ♥️♥️♥️♥️♥️ Go to for digital invites!!!',
  },
  {
    title: 'I ♥️it!',
    date: 'Oct 28',
    reviewer: 'Joyjoyjoy2004',
    color: '#F8F8F8',
    content:
      'This is my absolute favorite app for making collages and editing pictures! Once I learned how to find images from the web and remove backgrounds, it became the only app I needed usually just use the free version a few months I have bought the pro version because of the cute font, but I usually end up going back to the free one',
  },
  {
    title: 'The best editing/collage making app',
    date: 'Oct 21',
    reviewer: 'BrentEandCarmenD',
    color: '#F8F8F8',
    content: 'This app is very user friendly. I love it!',
  },
  {
    title: 'Definitely worth the app!',
    date: 'Oct 9',
    reviewer: 'Asharoo',
    color: '#F8F8F8',
    content:
      'I totally forgot I had this app and I’m so glad I found it, I was easily able to get some pictures of me as a baby & my child to compare side by side. Saving to my phone is easy enough & uploading to social media 😃',
  },
];
